import { StyleSheet, View, TouchableOpacity } from "react-native";
import React from "react";
import Text from "@components/CustomText";
import color from "@constants/color";
import t from "@constants/localization";

function DeliveryPerformanceTabBtn({ selectedTab, setSelectedTab }) {
  const PATH = "screens/DeliveryPerformance";
  return (
    <View style={styles.container}>
      <TouchableOpacity
        testID="dp-tab-btn"
        activeOpacity={0.8}
        onPress={() => setSelectedTab("today")}
        style={[
          styles.tabContainer,
          {
            backgroundColor:
              selectedTab === "today" ? color.mediumBlack : color.white,
          },
        ]}
      >
        <Text
          variant={selectedTab === "today" ? "body_text_2" : "body_text_3"}
          style={[
            styles.tabText,
            {
              color: selectedTab === "today" ? color.white : color.mediumBlack,
            },
          ]}
        >
          {t(`${PATH}/todayReport`)}
        </Text>
      </TouchableOpacity>
      <TouchableOpacity
        testID="dp-tab-btn"
        onPress={() => setSelectedTab("week")}
        activeOpacity={0.8}
        style={[
          styles.tabContainer,
          {
            backgroundColor:
              selectedTab === "week" ? color.mediumBlack : color.white,
          },
        ]}
      >
        <Text
          variant={selectedTab === "week" ? "body_text_2" : "body_text_3"}
          style={[
            styles.tabText,
            {
              color: selectedTab === "week" ? color.white : color.mediumBlack,
            },
          ]}
        >
          {t(`${PATH}/weeklyReport`)}
        </Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: color.white,
    paddingHorizontal: 16,
  },
  tabContainer: {
    borderRadius: 30,
    backgroundColor: color.white,
    padding: 12,
    borderColor: color.lighterBlack,
    borderWidth: 1,
    marginBottom: 12,
    width: "48%",
  },
  tabText: {
    textAlign: "center",
  },
});

export default DeliveryPerformanceTabBtn;
